export default {
  goodColumnList: [
    { type: 'checkbox', width: 50 },
    { type: 'index', width: 50 },
    {
      field: 'productNo',
      title: window.vm.$t('transportDeliveryOrder.form.good.productNo'),
      width: '120',
    },
    {
      field: 'productName',
      title: window.vm.$t('transportDeliveryOrder.form.good.productName'),
      width: '120',
    },
    {
      field: 'productUnit',
      title: window.vm.$t('transportDeliveryOrder.form.good.productUnit'),
      width: '120',
    },
    {
      field: 'businessOrder',
      title: window.vm.$t('transportDeliveryOrder.form.good.businessOrder'),
      children: [
        {
          field: 'businessOrderQuantity',
          title: window.vm.$t('transportDeliveryOrder.form.good.businessOrderQuantity'),
          width: '120',
        },
        {
          field: 'businessOrderPackage',
          title: window.vm.$t('transportDeliveryOrder.form.good.businessOrderPackage'),
          width: '120',
        },
      ],
    },
    {
      field: 'storageShouldSend',
      title: window.vm.$t('transportDeliveryOrder.form.good.storageShouldSend'),
      children: [
        {
          field: 'storageShouldSendQuantity',
          title: window.vm.$t('transportDeliveryOrder.form.good.storageShouldSendQuantity'),
          width: '120',
          editRender: { name: 'ElInput' },
        },
        {
          field: 'storageShouldSendPackage',
          title: window.vm.$t('transportDeliveryOrder.form.good.storageShouldSendPackage'),
          width: '120',
          editRender: { name: 'ElInput' },
        },
      ],
    },
    {
      field: 'storageSend',
      title: window.vm.$t('transportDeliveryOrder.form.good.storageSend'),
      children: [
        {
          field: 'storageSendQuantity',
          title: window.vm.$t('transportDeliveryOrder.form.good.storageSendQuantity'),
          width: '120',
          editRender: { name: 'ElInput' },
        },
        {
          field: 'storageSendPackage',
          title: window.vm.$t('transportDeliveryOrder.form.good.storageSendPackage'),
          width: '120',
          editRender: { name: 'ElInput' },
        },
      ],
    },
    {
      field: 'nameVoyageLicense',
      title: window.vm.$t('transportDeliveryOrder.form.good.nameVoyageLicense'),
      width: '120',
      editRender: { name: 'ElInput' },
    },
    {
      field: 'warehouseReceiptsNo',
      title: window.vm.$t('transportDeliveryOrder.form.good.warehouseReceiptsNo'),
      width: '120',
      editRender: { name: 'ElInput' },
    },
    {
      field: 'mark',
      title: window.vm.$t('transportDeliveryOrder.form.good.mark'),
      width: '120',
      editRender: { name: 'ElInput' },
    },
  ],
  feeColumnList: [
    { type: 'checkbox', width: 50 },
    { type: 'index', width: 50 },
    {
      field: 'expenseType',
      title: window.vm.$t('transportDeliveryOrder.form.outboundExpense.expenseType'),
      editRender: { name: 'select', option: this.expenseTypeList },
    },
    {
      field: 'expenseRate',
      title: window.vm.$t('transportDeliveryOrder.form.outboundExpense.expenseRate'),
      editRender: { name: 'ElInput' },
    },
    {
      field: 'outboundQuantity',
      title: window.vm.$t('transportDeliveryOrder.form.outboundExpense.outboundQuantity'),
      editRender: { name: 'ElInput' },
    },
    {
      field: 'outboundExpense',
      title: window.vm.$t('transportDeliveryOrder.form.outboundExpense.outboundExpense'),
      editRender: { name: 'ElInput' },
    },
  ],
};
